import React, { useContext, useEffect, useState } from "react";
import { Button, hasValue, Modal } from "uxp/components";
import { findSourceById, isStep } from "@utils";
import classNames from "classnames";
import { DataSourceType } from "@types";
import { Icon } from "uxp/components";
import { QueryBuilderContext } from "@query-builder/QueryBuilderContext";
import './ParamEditor.scss';
import { DEPillInput } from "@components/StepConfigurator/PillInput/DEPillInput";
export function isSourceConfigurable(source) {
    const params = Array.isArray(source === null || source === void 0 ? void 0 : source.params) ? source.params : [];
    return {
        isConfigurable: (source === null || source === void 0 ? void 0 : source.type) === DataSourceType.Query && params.length > 0,
        hasConfiguredAll: params.every(p => hasValue(p === null || p === void 0 ? void 0 : p.value))
    };
}
export const ParamsEditor = ({ source, onChange, query }) => {
    const [show, setShow] = useState(false);
    if (!source || !query)
        return null;
    const _source = findSourceById(query, source.id);
    if (!_source || isStep(_source))
        return;
    const { isConfigurable, hasConfiguredAll } = isSourceConfigurable(_source);
    if (!isConfigurable)
        return null;
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames("lqe_queryparamseditor__button-a238fc0e", {
                "lqe_queryparamseditor__button--invalid-a238fc0e": !hasConfiguredAll
            }), onClick: () => setShow(true) },
            React.createElement(Icon, { icon: ['fas', 'tools'] })),
        React.createElement(ParamEditorModal, { show: show, onClose: () => setShow(false), source: _source, onSave: updated => {
                onChange(Object.assign({}, updated));
                setShow(false);
            }, query: query }));
};
export const ParamEditorModal = ({ show, onClose, source, onSave, query }) => {
    const context = useContext(QueryBuilderContext);
    const $L = (key) => context.uxpContext.$L(key);
    const [params, setParams] = useState([]);
    useEffect(() => {
        setParams((source === null || source === void 0 ? void 0 : source.params) || []);
    }, [source, show]);
    function renderEditor() {
        return React.createElement("div", { className: classNames("lqe_queryparamseditor-a238fc0e") }, (params || []).map((param, i) => {
            return React.createElement("div", { className: "lqe_queryparamseditor__param-a238fc0e" },
                React.createElement("div", { className: "lqe_queryparamseditor__param-label-a238fc0e" }, param.name),
                React.createElement("div", { className: "lqe_queryparamseditor__param-value-a238fc0e" },
                    React.createElement(DEPillInput, { value: (param === null || param === void 0 ? void 0 : param.value) || '', onChange: v => setParams(prev => {
                            prev[i].value = v;
                            return [...prev];
                        }), query: query })));
        }));
    }
    return React.createElement(Modal, { show: show, onClose: onClose, title: `${$L('lqe.pe.configure-title')} ${source === null || source === void 0 ? void 0 : source.name}`, className: "lqe_queryparamseditor__modal_container-a238fc0e" },
        renderEditor(),
        React.createElement("div", { className: "lqe_queryparamseditor__modal_footer-a238fc0e" },
            React.createElement(Button, { title: $L('lqe.pe.save-continue'), onClick: () => onSave(Object.assign(Object.assign({}, source), { params: params })) })));
};
